<template>
  <a href="#" class="thumbBox" @click.prevent="linkHandler">
    <!-- <img :src="require(`@/assets/image/${ thumb.img }`)"> -->
    <div class="imgBox" :style="{
      '--img-width' : `${ imgMaxWidth }px`, 
      '--img-height' : `${ imgMaxHeight }px`, 
    }">
      <img 
        :src="`data:image/png;base64,${ thumb.thumbnail }`" 
        :style="imgSize"
      >
    </div>
    <span><label v-html="thumb.processName"></label></span>
  </a>
</template>


<script>
import commnew from "@/store/commnew";
import { commNewMapGetters , commNewMapMutations , commNewMapActions } from "@processEditor/CommNew";
export default {
  props : {
    thumb : Object , 
    closeHandler : Function , 
  } , 

  data () {
    return {
      imgMaxWidth : 296 , 
      imgMaxHeight : 200 , 
      cssWidth : 0 , 
      cssHeight : 0 , 
    } 
  } , 

  computed : {
    ...commNewMapGetters([
      'crntDiagram' , 
    ]) , 
    imgSize () {
      return {
        width : `${ this.cssWidth }` , 
        height : `${ this.cssHeight }` , 
      }
    } , 
  } , 

  mounted () {
    let { thumb } = this ; 
    let img = new Image ; 

    img.onload = _ => {
      if ( this.imgMaxWidth < img.naturalWidth ) {
        this.cssWidth = '90%' ; 
      } else {
        this.cssWidth = img.naturalWidth+'px' ; 
      }

      if ( this.imgMaxHeight < img.naturalHeight ) {
        this.cssHeight = 'auto' ; 
      } else {
        // this.cssHeight = img.naturalHeight+'px' ; 
        this.cssHeight = 'auto' ; 
      }
    } ; 

    img.src = `data:image/png;base64,${ thumb.thumbnail }` ; 
  } , 

  methods : {
    ...commNewMapMutations([
      'setCrntPos' , 
    ]) , 
    ...commNewMapActions([
      'setTemplateData' , 
      'setTemplateLNBInfo' , 
      'setTemplateDiagramInfo' , 
    ]) , 
    async linkHandler ( e ) {
      const { processId } = this.thumb ; 
      const response = await this.$wApi.process.detail( null , processId ) ; 
      const data = JSON.parse( response.json ) ; 

      this.setCrntPos({ x : e.pageX , y : e.pageY }) ; 
      
      /* 
      let testData = data.nodes[0]; 
      // console.log( 'data : ', data ) ; 
      // console.log( 'testData :' , testData ) ; 
      const newNode = {
        category : testData.category , 
        key : testData.key , 
        linkValidation : testData.linkValidation , 
        position: testData.position , 
        tagId : testData.tagId , 
        text : testData.text , 
        shape : testData.shape , 
        protocol : null , 
        hasProtocol : undefined , 
      } ; 

      // console.log( 'this.crntDiagram : ' , this.crntDiagram ) ; 
      this.crntDiagram.model.addNodeData( newNode ) ; 
      */
      
      
      this.setTemplateData( data ) ; 

      /* this.setTemplateLNBInfo( data ) ; 
      this.setTemplateDiagramInfo( data ) ;  */

      this.closeHandler() ; 
    } , // end of linkHandler
  } , 
}
</script>

<style lang="scss" scoped>
  .thumbBox {
    display: flex; 
    flex-direction: column; 
    flex-shrink: 0;
    gap: var( --default-gap ); 

    .imgBox {
      display: flex; 
      justify-content: center; 
      align-items: center; 
      width: var( --img-width ); 
      height: var( --img-height ); 
      border: 1px solid $gray-9;
    }
    
    span {
      text-align: center;  
      font-size: 14px; 
      color: $gray-3; 
      @include text-prt; 
      @include text-prt-b; 
    }
  }
</style>